export const SUPPORTED_LOCALES = ['sk', 'cs'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = 'sk';
const COOKIE_NAME = 'dr_locale';
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export function isLocale(value: string | undefined | null): value is Locale {
  return value === 'sk' || value === 'cs';
}

function readCookieLocale(): Locale | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]+)`));
  const value = match?.[1];
  return isLocale(value) ? value : null;
}

function readNavigatorLocale(): Locale | null {
  if (typeof navigator === 'undefined') return null;
  for (const lang of navigator.languages ?? [navigator.language]) {
    const code = lang.toLowerCase().slice(0, 2);
    if (isLocale(code)) return code;
  }
  return null;
}

function readPathLocale(): Locale | null {
  if (typeof window === 'undefined') return null;
  const segment = window.location.pathname.split('/')[1];
  return isLocale(segment) ? segment : null;
}

export function detectLocale(): Locale {
  return readPathLocale() ?? readCookieLocale() ?? readNavigatorLocale() ?? DEFAULT_LOCALE;
}

export function persistLocale(locale: Locale): void {
  if (typeof document === 'undefined') return;
  const isSecure = window.location.protocol === 'https:';
  const attrs = [
    `${COOKIE_NAME}=${locale}`,
    `Path=/`,
    `Max-Age=${COOKIE_MAX_AGE_SECONDS}`,
    `SameSite=Lax`,
  ];
  if (isSecure) attrs.push('Secure');
  document.cookie = attrs.join('; ');
}
